<template>
  <ImageMedia
    data-private
    :class="isotype ? 'isotype' : 'rever-logo'"
    :src="logo"
    :defaultImage="defaultImage"
  />
</template>

<script>
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import defaultLogo from '@/assets/images/logo-rever.svg'
import defaultIsotype from '@/assets/images/rever-isotype.svg'
import defaultLogoWhite from '@/assets/images/logo-rever-text-white.svg'
import defaultIsotypeWhite from '@/assets/images/rever-isotype-white.svg'

export default {
  name: 'OrganizationLogo',

  props: {
    isotype: Boolean,
    type: String,
  },

  components: {
    ImageMedia,
  },

  computed: {
    logo() {
      const logo = this.$store.state.access.logoMediaObject
      if (logo && this.isotype) return null
      return typeof logo === 'object' ? logo : null
    },

    defaultImage() {
      const hasCustomLogo = Boolean(this.$store.state.access.logoMediaObject)
      if (!hasCustomLogo)
        return this.isotype ? this.reverIsotype : this.reverLogo
      return null
    },

    reverLogo() {
      return this.type === 'white' ? defaultLogoWhite : defaultLogo
    },

    reverIsotype() {
      return this.type === 'white' ? defaultIsotypeWhite : defaultIsotype
    },
  },
}
</script>

<style lang="scss" scoped>
.rever-logo {
  object-fit: contain;
  height: 34px;
  width: 123px;
}

.isotype {
  max-height: 34px;
}
</style>
